module.exports = __webpack_public_path__ + "static/media/favicon.ae9817e7.ico";